import { render } from "./QuestionAndAnswer.vue?vue&type=template&id=1e0d8428"
import script from "./QuestionAndAnswer.vue?vue&type=script&lang=js"
export * from "./QuestionAndAnswer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/content/QuestionAndAnswer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e0d8428"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e0d8428', __exports__)) {
    api.reload('1e0d8428', __exports__)
  }
  
  module.hot.accept("./QuestionAndAnswer.vue?vue&type=template&id=1e0d8428", () => {
    api.rerender('1e0d8428', render)
  })

}


export default __exports__